module.exports = __webpack_public_path__ + "img/ld_3@2x.737d7c09.png";